import React, { useContext } from "react";
import { Card, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Stack } from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";

import ContactCard from "./ContactCard";
import { AppContext } from "../Store";

const ChildCard: React.FC<any> = ({ child }) => {

  const context = useContext(AppContext);
  const { userContext } = context;

  const [otherContactsOpen, setOtherContactsOpen] = React.useState(false);

  const handleClickOpenOtherContacts = () => {
    setOtherContactsOpen(true);
  };

  const handleCloseOtherContacts = () => {
    setOtherContactsOpen(false);
  };

  return (
    <Card variant="outlined">

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ContactCard
            data={{
              type: "Parent 1",
              name: child.registration.parent1FullName,
              phone: child.registration.parent1Phone,
              address: child.registration.parent1Address,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <ContactCard
            data={{
              type: "Parent 2",
              name: child.registration.parent2FullName,
              phone: child.registration.parent2Phone,
              address: child.registration.parent2Address,
            }}
          />
          <Grid item xs={12}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Button variant="contained" color="primary" fullWidth style={{ marginTop: "15px" }} onClick={handleClickOpenOtherContacts} className="no-print">
                More
              </Button>
              {
                userContext.isTeacher() && (
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    className="no-print"
                    style={{ marginTop: 0 }}
                    href={child?.id ? `/child/${child.id}/observations-report` : undefined}
                    target="_blank"
                  >
                    Report
                  </Button>
                )
              }
            </div>
          </Grid>
        </Grid>
      </Grid>


      <Dialog
        open={otherContactsOpen}
        onClose={handleCloseOtherContacts}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Other contacts</DialogTitle>
        <DialogContent>
          {
            userContext.isTeacher() &&
            <DialogContentText id="alert-dialog-description">
              <WarningIcon /> Do not forget to ask for Code Word when child is collected by a new person.
            </DialogContentText>
          }

          <Stack spacing={2}>
            <ContactCard
              data={{
                type: "Emergency Contact",
                name: child.registration.emergencyContactFullName,
                rel: child.registration.emergencyContactRelationship,
                phone: child.registration.emergencyContactPhone,
                address: child.registration.emergencyContactAddress,
                email: child.registration.emergencyContactEmail,
              }}
            />
            <ContactCard
              data={{
                type: "Other Collector",
                name: child.registration.otherCollectorFullName,
                rel: child.registration.otherCollectorRelationship,
                phone: child.registration.otherCollectorPhone,
                extra: `Code Word: ${child.registration.otherCollectorCodeWord}`,
              }}
            />
            <ContactCard
              data={{
                type: "Doctor",
                name: child.registration.doctorFullName,
                org: child.registration.doctorPractice,
                phone: child.registration.doctorPhone,
              }}
            />
            <ContactCard
              data={{
                type: "Health Visitor",
                name: child.registration.healthVisitorFullName,
                org: child.registration.healthVisitorOrganisation,
                phone: child.registration.healthVisitorPhone,
                address: child.registration.healthVisitorAddress,
              }}
            />
            <ContactCard
              data={{
                type: "Social Care Worker",
                name: child.registration.socialCareWorkerFullName,
                org: child.registration.socialCareWorkerOrganisation,
                phone: child.registration.socialCareWorkerPhone,
                address: child.registration.socialCareWorkerAddress,
              }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseOtherContacts} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default ChildCard;
